import { ConsumptionFile } from 'src/app/filemanagement/UdFile';
import { UtilityRateCode } from './utility-rate-code';
import { ClassValidation } from '../services/utility-account.service';
import { Address, UtilityDetails } from './customer-details';
import { UtilityInformation } from './utility-information';

export class UtilityAccount {
  public utilityAccountId?: number;
  public utilityAccountNumber?: string;
  public rateCode?: string;
  public rateClass?: string;
  public validationInfo?: ClassValidation;
  public newContractStartDate?: string;
  public contractEndDate?: string;
  public rateCodeDetails?: UtilityRateCode;
  public consumptionData?: ConsumptionData;
  public utilityDetails?: UtilityDetails;
  public address?: Address;
  public annualUsageUOM?: string;
  public nameKey?: string;  
  public serviceKey?: string;  
  public meterNumber?: string;
}

export class UtilityAccountModel {
  public annualUsage: number;
  public UtilityDetails: UtilityAccount[];
}

export class ConsumptionData {
  public consumptionDataRequested: boolean;
  public consumptionDataRequestedErrored: boolean;
  public consumptionDataReceived: boolean;
  public meterDataRequests: MeterDataRequest[];
  public dateRequested?: Date;
  public lastModified?: Date;
  public source: string;
  public dataFile: ConsumptionFile;
}

export class MeterDataRequest {
  public pending: boolean;
  public success: boolean;
  public failed: boolean;
  public requestType: string;
}

export interface UtilitiesByZipCode {
  zipCode: string;
  utilityInformation: UtilityInformation[];
}

export interface RateCodesByUtilityShort {
  utilityShort: string;
  utilityRateCodes: UtilityRateCode[];
}